import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  computed, watch,
} from 'vue';
import { useRoute } from 'vue-router';
import useQuasar from 'quasar/src/composables/use-quasar.js';;
import defaultLayout from '@/layouts/default.vue';
import panelLayout from '@/layouts/panel.vue';
import Layout from '@/types/Layout';
import { useGlobalStore } from '@/stores';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const globalStore = useGlobalStore();
const $q = useQuasar();
const $route = useRoute();

const componentLayout = computed(() => ($route.meta?.layout || Layout.default));

const loading = computed(() => globalStore.loading);

watch(loading, (newLoading) => {
  $q.loading.isActive = newLoading;
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_resolveDynamicComponent(componentLayout.value === _unref(Layout).panel ? panelLayout : defaultLayout), null, {
    default: _withCtx(() => [
      _createVNode(_component_router_view)
    ]),
    _: 1
  }))
}
}

})